import { useMemo } from 'react';

import { LANGUAGES } from '../constants';

const useLanguagesOptions = () => {
  return useMemo(
    () => [
      {
        label: 'English',
        value: LANGUAGES.ENGLISH,
        icon: '🇬🇧',
      },
      {
        label: 'German',
        value: LANGUAGES.GERMAN,
        icon: '🇩🇪',
      },
      {
        label: 'Danish',
        value: LANGUAGES.DANISH,
        icon: '🇩🇰',
      },
    ],
    [],
  );
};

export default useLanguagesOptions;
